import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AppDataService,
  GetCorePageDataService,
  FormBuildService,
  GlobalVariablesService,
  DocumentService,
  StepRequest,
  StepsService
} from '@tmhcc-ng-lib/data-service';
import { FormBuilder } from '@angular/forms';
import {
  AppConfigService,
  SaveChangeGaurd
} from '@tmhcc-ng-lib/global-services';
import { Config, Menu } from '@tmhcc/artisan-edge';
import { BaseUCMFormsComponent } from '../base-ucm-forms.component';
import { UCMSharedService } from '../ucm-shared.service';
import { AccordionService } from '../../accordion-menu/accordion.service';
import { AllowedGLNavRoutes } from 'libs/models/enums/gl-menus.model';

import { AutoDeclineService } from '../../common-liability/auto-decline/auto-decline.service';
import { RefreshPageService } from '../../common-liability/nevigation/refresh-page.service';

@Component({
  selector: 'ac-ucm-forms',
  templateUrl: './gl-ucm-forms.component.html',
  styleUrls: ['./gl-ucm-forms.component.scss']
})
export class GeneralLiabilityUCMComponent extends BaseUCMFormsComponent
  implements OnInit, AfterViewInit {
  apiEndpoint: string;
  apiKey: string;
  isFormRendered: boolean;
  hideTopSummary: boolean;
  coverageBtnStatus = '';
  readonlyStatus: boolean;
  disabledClass = '';
  policyType: string;

  constructor(
    protected router: Router,
    protected globalVariables: GlobalVariablesService,
    protected getSiteCoreDataService: GetCorePageDataService,
    protected ucmService: UCMSharedService,
    protected formBuildService: FormBuildService,
    protected loaderService: LoaderService,
    protected activeRouter: ActivatedRoute,
    protected documentService: DocumentService,
    protected appDataService: AppDataService,
    private formBuilder: FormBuilder,
    protected configService: AppConfigService,
    private saveChangeGaurd: SaveChangeGaurd,
    protected accordionService: AccordionService,
    protected stepsService: StepsService,
    protected autoDeclineService: AutoDeclineService,
    private refreshPageService: RefreshPageService
  ) {
    super(
      router,
      globalVariables,
      getSiteCoreDataService,
      ucmService,
      formBuildService,
      loaderService,
      activeRouter,
      documentService,
      appDataService,
      autoDeclineService,
      stepsService,
      accordionService,
      configService
    );
    this.apiEndpoint = this.configService.config.dataServiceBaseUrl;
    this.apiKey = this.configService.config.dataServiceApiKey;

    //this.refreshPageService.pageRefresh();
  }
  currentUrl = 'artisan';
  menus: Menu[];
  options: Config = { multi: false };

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.appDataService.stepsSitecoreContent.next();
    this.setElementDefault();
    this.initFormGroup();
    this.saveChangeGaurd.setFormGroup(this.ucmFormGroup);
    super.ngOnInit();

    this.activeRouter.params.subscribe(params => {
      let prodType = this.globalVariables.productName;
      if (
        this.globalVariables.allSteps[prodType]['/ucm-forms/gl-liability'] ===
        true
      ) {
        this.globalVariables.isSummaryEnable = 'true';
      }

      if (
        (this.router.url !== AllowedGLNavRoutes.Insured &&
          this.router.url !== AllowedGLNavRoutes.Owner &&
          this.router.url !== AllowedGLNavRoutes.Ratings) ||
        this.globalVariables.isSummaryEnable == 'true'
      ) {
        this.appDataService.summarySitecoreContent.next();
        this.appDataService.showSummary.next(true);
        let payload: StepRequest = {
          policyId: this.globalVariables.policyId,
          versionNum: this.globalVariables.policyVersionId
        };
        // if (
        //   this.globalVariables.policyId &&
        //   this.globalVariables.policyId > 0
        // ) {
        //   this.appDataService.fetchAndPublishPolicyDetails(payload);
        // }
      } else {
        this.appDataService.showSummary.next(false);
      }
    });
  }
  ngAfterViewInit() {}
  initFormGroup() {
    const controls = {};
    this.ucmFormGroup = this.formBuilder.group(controls);
  }
}
